import React, { useEffect, useMemo, useState } from "react";

import { TopBar } from "components/top-bar";
import { Footer } from "components/footer";

type Props = {
    children: React.ReactNode
}

export const BasePage = ({
    children
}: Props) => {
    const [windowHeight, setWindowHeight] = useState(window.innerHeight);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [bodyHeight, setBodyHeight] = useState(document.body.clientHeight);

    useEffect(() => {
        const resizeListener = () => {
            setWindowHeight(window.innerHeight);
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', resizeListener);

        const bodyObserver = new ResizeObserver(() => setBodyHeight(document.body.clientHeight));

        bodyObserver.observe(document.body);
        return () => {
            bodyObserver.disconnect();
            window.removeEventListener('resize', resizeListener);
        };
    }, []);

    const sticky = useMemo(() => bodyHeight < windowHeight && windowWidth > 768, [bodyHeight, windowHeight, windowWidth]);

    return <>
        <TopBar />
        <div>
            {children}
        </div>
        <Footer sticky={sticky} />
    </>;
}
